export default __webpack_public_path__ + "static/media/bank_line.daa8262f.svg";